<template>
  <div class="videoContainer">
    <div class="navBarContainerLeft">
      <div class="left">
        <span class="backBox">
          <img
            src="../assets/img/video/back.png"
            alt
            @click="back"
            width="100%"
          />
        </span>
        <span class="homeBox">
          <img
            src="../assets/img/video/home.png"
            alt
            @click="gotoHomePage"
            width="100%"
          />
        </span>
      </div>
    </div>

    <van-swipe
      class="mySwiper"
      vertical
      :loop="false"
      :show-indicators="false"
      :initial-swipe="initSwiperItem1"
      @change="changeSwiper"
    >
      <van-swipe-item
        class="swiperItem"
        v-for="(item, index) in freeVideoList"
        :key="index"
      >
        <!--ios---->
        <video
          :src="item.url"
          :id="'video'+index"
          v-if="isIos"
          webkit-playsinline
          playsinline
          x5-playsinline
          object-fit:fill

          @waiting="videoWaiting($event)"
          @error='error($event)'

          @click="pauseVideo()"
          @play="playVideo()"
          @ended="onPlayerEnded($event)"
          @timeupdate="onPlayerTimeUpDate($event, index)"
        ></video>
        <!--android-->
        <video
          :src="item.url"
          :id="'video'+index"
          v-else
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          object-fit:fill
          @click="pauseVideo()"
          @ended="onPlayerEnded($event)"
          @timeupdate="onPlayerTimeUpDate($event, index)"
        ></video>

        <div class="play-box" v-show="isShowPlayImg" @click="playVideo(index)">
          <img src="../assets/img/video/icon_video_play_big@2x.png" alt />
        </div>

        <div class="play-box" v-show="noClickPlayImg">
          <img src="../assets/img/video/icon_video_play_big@2x.png" alt />
        </div>

        <div class="bottom-box">
          <p class="className">@{{item.belongLesson}}</p>
          <p class="part-Box">
            <span>{{ item.lessonsTitle }}</span>
            <span class="line"></span>
            <span ref="videoTitle">{{ item.title }}</span>
          </p>
          <div class="listBox-fullScreen">
            <p class="listBox" @click="showListBox()">
              <span class="left">
                <img src="../assets/img/video/video.png" alt />
                <span>目录</span>
              </span>
              <img
                src="../assets/img/video/icon_video_arrow_r@2x.png"
                alt
                class="right"
              />
            </p>

          </div>
        </div>

        <van-progress
          :percentage="progress"
          stroke-width="1"
          :show-pivot="false"
          color="red"
        />
      </van-swipe-item>
    </van-swipe>

    <!--列表弹出框-->
    <div class="listBoxWrapper" v-show="isShowListBox">
      <div class>
        <div class="top-box">
          <span>
            共{{ freeVideoList.length }}课时
          </span>
          <img
            src="../assets/img/video/icon_course_list_close@2x.png"
            alt
            @click="closeListBox()"
          />
        </div>
        <div class="list-box">
          <div
            v-for="(item, index) in freeVideoList"
            :key="index"
            class="listItem"
            @click="changeVideo(index)"
          >
            <div class="left">
              <img
                src="../assets/img/video/icon-bofang@2x.png"
                alt
                v-show="index == videoIndex1"
                class="playImg"
              />
              <img
                src="../assets/img/video/icon-zanting@2x.png"
                alt
                v-show="index != videoIndex1"
                class="playImg"
              />
              <span
                :style="index == videoIndex1 ? 'color:white' : 'color:#aaa'"
              >
                <span>{{ item.lessonsTitle }}</span>
                <span style="margin-left: 5px">{{ item.title }}</span>
              </span>
            </div>
            <div class="right">
              <span class="isFree">试看</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <van-overlay :show="showGuide" @click="showGuide = false" class="mypopup">
      <div class="con">
        <div class="con-cen">
          <img src="../assets/images/guide/jpg-huadong@2x.png" alt="" class="gesture-bg">
          <img src="../assets/images/guide/icon-shoushi@2x.png" alt="" class="gesture">
        </div>
        <div class="con-btm">
          <img src="../assets/images/guide/icon-click.png" alt="" class="all">
          <div class="listBox-fullScreen">
            <p class="listBox">
              <span class="left">
                <img src="../assets/img/video/video.png" alt />
                <span>目录</span>
              </span>
              <!-- <img src="../assets/img/video/icon_video_arrow_r@2x.png" alt class="right"/> -->
              <span class="right"></span>
            </p>
          </div>
        </div>
      </div>   
    </van-overlay>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../api/api";
import { Dialog, Toast,Overlay } from "vant";
import utils from "../utils/utils";
export default {
  data() {
    return {
      initSwiperItem1: 0,   //默认开始播放视频

      videoIndex1: 0,   //当前正在播放视频

      //试看视频
      freeVideoList:[],

      //课程分类
      courseCatagory:"",

      isShowPlayImg: true,

      progress: 0,

      isShowListBox: false,

      //api
      query: {
        shopId: "",
        courseId: "",
        productId: "",
      },

      noClickPlayImg: false,

      isIos: "",
      currentPlayTime: 0,

      showGuide:false //新手指引
    };
  },
  watch: {},
  computed: {
    currentVideoData() {
      return this.freeVideoList[this.videoIndex1];
    },
    currentVideo() {
      return $("video")[this.videoIndex1];
    },
    isPaused() {
      return $("video")[this.videoIndex1].paused;
    },

  },
  created() {
    this.freeVideoList=this.$route.query.freeVideoList;
    console.log(this.freeVideoList,'========freeVideoList=======')

    this.videoIndex1 = this.$route.query.videoIndex;

    this.courseCatagory = this.$route.query.courseCatagory;

    document.title = "学习";

    this.query.shopId = parseInt(localStorage.getItem("shopId"));

    this.query.courseId = localStorage.getItem("courseId");

    this.query.productId = parseInt(localStorage.getItem("productId"));

    this.videoIndex1 = parseInt(this.$route.query.videoIndex);
    this.initSwiperItem1 = parseInt(this.$route.query.videoIndex);

    if (utils.isAndroid()) {
      this.isIos = false; //android
    } else {
      this.isIos = true; //ios
    }

  },
  mounted() {
    //新手指引
    let notFirstTimeVideoPage=localStorage.getItem('notFirstTimeVideoPage')
    // console.log(notFirstTimeVideoPage)
    if(!notFirstTimeVideoPage){
      this.showGuide=true
      localStorage.setItem('notFirstTimeVideoPage',true)      
    }
  },
  //离开页面
  destroyed() {
    this.pauseVideo();
  },
  methods: {
    error(){
      console.log('视屏播放出错...')
      // alert('视屏播放出错...')
    },
    videoWaiting(){
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
    },
    //切换视频
    changeSwiper(index) {
      // console.log("切换视频:",index)
      if(this.isIos){
        this.isShowPlayImg = true;
      }
      // 最近观看记录保存到本地
      localStorage.setItem(
        "videoTitle",
        this.$refs.videoTitle[index].innerHTML
      );

      //暂停当前
      let nowVideo = $("video")[this.videoIndex1];
      nowVideo.pause();

      this.videoIndex1 = index;

      //播放下一个视频
      let nextVideo = $("video")[index];

      if (this.canPlayVideo()) {
        nextVideo.play();

        // this.isShowPlayImg = false;
        this.noClickPlayImg = false;        
      }
    },
    playVideo(){
      if(this.isShowPlayImg){
        this.isShowPlayImg=false
      }
      Toast.clear();
    },

    //监听播放进度
    onPlayerTimeUpDate(player, index) {
      
      let video = this.currentVideo;
      //当前播放时间
      if(video.currentTime){
        this.currentPlayTime = video.currentTime.toFixed(2);
      }

      //console.log(this.currentVideoData)


      let duration = "";
      
      duration = this.currentVideoData.duration;


      if (this.currentPlayTime > 0 && duration > 0) {
        if (0 < parseFloat(this.currentPlayTime) < duration) {
          this.progress = (this.currentPlayTime / duration) * 100;
        }
      }
    },

    //点击播放视频
    playVideo() {
      let video = this.currentVideo;
      if (this.canPlayVideo()) {
        video.play();

        this.isShowPlayImg = false;
        this.noClickPlayImg = false;
      }else{
        concole.log("无法播放")
      }
    },

    pauseVideo() {
      //console.log(index)
      let video = this.currentVideo;
      if (video) {
        video.pause();
      }
      this.isShowPlayImg = true;
    },

    onPlayerEnded(player) {
      this.isShowPlayImg = true;
      this.currentVideoData.isEnd = true;

      console.log("播放结束");
    },
    //点击视频列表
    changeVideo(index) {
      //暂停当前
      let nowVideo = $("video")[this.videoIndex1];
      nowVideo.pause();

      localStorage.setItem(
        "videoTitle",
        this.$refs.videoTitle[index].innerHTML
      );

      this.videoIndex1 = index;
      this.initSwiperItem1 = index;

      //播放下一个视频
      let nextVideo = $("video")[index];

      if (this.canPlayVideo()) {
          nextVideo.play();

          this.isShowPlayImg = false;
          this.noClickPlayImg = false;
       // }
      }

      this.isShowListBox = false;
    },

    //是否可以播放
    canPlayVideo() {
      return true

    },
   
    cancel() {
      return;
    },

    showListBox() {
      this.isShowListBox = true;
    },
    closeListBox() {
      this.isShowListBox = false;
    },
    back() {
      this.$router.go(-1);
    },
    gotoHomePage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.videoContainer {
  width: 100%;
  height: 100vh;
  background: black;
  overflow: hidden;
  img {
    vertical-align: middle;
  }
  .navBarContainerLeft {
    width: 100%;
    padding: 3% 4%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    z-index: 99;
    img {
      // width: 16px;
      // height: 20px;
    }
    .backBox,
    .homeBox,
    .shareBox {
      width: 20px;
      height: 20px;
      display: flex;
    }
    .backBox {
      padding-right: 10px;
      border-right: 1px solid #ece9e9;
    }
    .homeBox {
      padding-left: 10px;
    }
    .left,
    .right {
      border: 1px solid rgba(236, 233, 233, 1);
      padding: 4px 11px;
      border-radius: 14px;
      display: flex;
      align-items: center;
    }
  }
  .mySwiper {
    width: 100%;
    height: 100vh;
    .swiperItem {
      height: 100vh;
      position: relative;
      video {
        width: 100vw;
        height: 100vh;
        touch-action: none;
        z-index: -1;
      }
      video::-webkit-media-controls {
        display: none !important;
      }
      // .video-player{
      //   width: 100%;
      //   height: 100%;
      // }
      // .pauseVideoWrapper{
      //   width:100%;
      //   height:calc(100% - 23%);
      //   z-index:99;
      //   position: absolute;;
      //   top:0;left:0
      // }
      .play-box {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-20px, -20px);
        z-index: 99;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .bottom-box {
        width: 100%;
        position: absolute;
        bottom: 2%;
        left: 0;
        color: white;
        text-align: left;
        padding: 0 14px 24px 14px;
        z-index: 99;
        box-sizing: border-box;
        .className {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
        }
        .part-Box {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          margin-top: 12px;
        }
        
      }
      .van-progress {
        position: absolute;
        bottom: 2%;
        left: 0%;
        width: 100%;
      }
    }
  }
  .listBox-fullScreen {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .listBox {
      width: 32%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba($color: #fff, $alpha: 0.15);
      border-radius: 19px;
      padding: 3% 3%;
      margin-top: 15px;
      .left {
        font-size: 15px;
        line-height: 17px;
        max-width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color:#fff;
        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }
      .right {
        width: 12px;
        height: 12px;
      }
    }
    .full-screen {
      width: 80px;
      height: 40px;
      background: rgba($color: #fff, $alpha: 0.15);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 15px;
        height: 15px;
        margin-right: 6px;
        vertical-align: middle;
      }
      span {
        font-size: 15px;
      }
    }
  }
  .listBoxWrapper {
    font-size: 1rem;
    width: 100%;
    max-height: 45vh;
    min-height: 30vh;
    overflow-y: scroll;
    background: rgba(49, 49, 49, 1);
    border-radius: 20px 20px 0px 0px;
    position: fixed;
    bottom: 0;
    left: 0;
    color: #aaaaaa;
    padding-bottom: 8%;
    padding-top: 1%;
    .top-box {
      font-size: 0.95rem;
      font-weight: 400;
      padding: 3% 0 2%;
      text-align: center;
      position: relative;
      span {
        position: absolute;
        left: 4%;
        top: 20%;
      }
      img {
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        right: 3%;
        top: 20%;
      }
    }
    .list-box {
      padding-top: 3%;
      .listItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2% 4%;
        font-size: 1rem;
        .left {
          max-width: calc(100% - 25%);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
        }
        .right {
          width: 27%;
          flex-shrink: 0;
          box-sizing: border-box;
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .isFree {
          font-size: 0.8rem;
          color: #ff3b57;
          // padding-right:2%;
        }
        .playImg {
          width: 16px;
          height: 16px;
        }
        .lockImg {
          width: 14px;
          height: 14px;
        }
        .rightArrow {
          width: 12px;
          height: 12px;
          margin-left: 2%;
        }
      }
    }
  }
  .mypopup{
    width:100vw;
    height: 100vh;
    .con{
      width: 100%;
      height:100%;
      position: relative;
      .con-cen{
        width: 100%;
        position: absolute;
        top:45%;
        left:0;
        transform: translate(0,-64px);
        .gesture-bg{
          width: 128px;
          height:210px ;
        }
        .gesture{
          width:40px;
          height:38px;
          position: absolute;
          top: calc(50% - 38px);
          left:50%;
          animation: gestureMove 3s infinite;
        }

      }
      .con-btm{
        width: 100%;
        position: absolute;
        bottom: calc(2% + 24px);
        left: 14px;
        text-align: left;
        .all{
          width: 206px;
          height: 98px;
          margin-bottom: -5%;
        }
        .listBox{
          background-color: #fff;
          margin-top:0;
          .left{
            color:#333;
            display: flex;
            align-items: center;
          }          
          .right{
            width: 5px;
            height:5px;
            border-top:1px solid #999;
            border-right: 1px solid #999;
            transform: rotate(45deg);
          }
        }
      }

      @keyframes  gestureMove{
        0%{
          transform: translateY(0px);
        }
        50%{
          transform: translateY(-30px);
        }
        100%{
          transform: translateY(0px);
        }
      }
    }
    
  }
}
</style>
